// Genera file .ics (iCalendar) dal piano di studio
export function generateICS(plan: any): string {
  const lines: string[] = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Study Planner Schedule//IT",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
  ]

  for (const day of plan.days) {
    if (day.isRestDay) continue

    if (day.isExamDay) {
      const dateObj = new Date(day.date)
      const dateStr = dateObj.toISOString().replace(/[-:]/g, "").split("T")[0]
      lines.push(
        "BEGIN:VEVENT",
        "UID:exam-" + dateStr + "-" + (day.examName || "").replace(/\s/g, "-") + "@studyplanner",
        "DTSTART;VALUE=DATE:" + dateStr,
        "DTEND;VALUE=DATE:" + dateStr,
        "SUMMARY:ESAME: " + day.examName,
        "DESCRIPTION:Giorno dell'esame",
        "END:VEVENT"
      )
      continue
    }

    for (const sub of day.subjects || []) {
      const dateObj = new Date(day.date)
      const dateStr = dateObj.toISOString().replace(/[-:]/g, "").split("T")[0]
      const uid = dateStr + "-" + (sub.examName || "").replace(/\s/g, "-") + "-" + Math.random().toString(36).slice(2) + "@studyplanner"
      const summary = sub.isRevision
        ? "Ripasso: " + sub.examName
        : sub.examName + " p. " + sub.startPage + "-" + sub.endPage
      const description = sub.isRevision
        ? "Sessione di ripasso per " + sub.examName
        : "Studia " + sub.pages + " pagine - " + sub.minutes + " minuti"
      lines.push(
        "BEGIN:VEVENT",
        "UID:" + uid,
        "DTSTART;VALUE=DATE:" + dateStr,
        "DTEND;VALUE=DATE:" + dateStr,
        "SUMMARY:" + summary,
        "DESCRIPTION:" + description,
        "END:VEVENT"
      )
    }
  }

  lines.push("END:VCALENDAR")
  return lines.join("\r\n")
}

export function downloadICS(plan: any) {
  const content = generateICS(plan)
  const blob = new Blob([content], { type: "text/calendar;charset=utf-8" })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = "piano-studio.ics"
  a.click()
  URL.revokeObjectURL(url)
}
